<template>
	<div class="container">
		<div class="top_title">
			<span class="logo"></span>
		</div>
		<div class="scroll_area" style="overflow-y: auto">
			<div class="banner"></div>
			<div class="menu_items">
				<div v-for="item,index in info.dataList" class="item">
					<div class="item_top">
						<span class="icon_menu" :style="{ 'background-image': 'url(' + item.I_MENU_TYPE_ICON + ''}"></span>
						<span class="title">{{item.I_MENU_TYPE_NAME}}</span>
					</div>
					<div class="menus">
						<template v-for="n in item.menuList">
							<a v-if="n.I_HTML_NAME.indexOf('http') > -1" class="menu" :href="n.I_HTML_NAME">
								<img :src="n.I_MENU_ICON" />
								<p>{{n.I_MENU_NAME}}</p>
							</a>
							<router-link v-if="n.I_HTML_NAME.indexOf('http') == -1" class="menu" :to="'/' + n.I_HTML_NAME" :key="n.id" tag="div">
								<img :src="n.I_MENU_ICON" />
								<p>{{n.I_MENU_NAME}}</p>
							</router-link>
						</template>
					</div>
				</div>
			</div>
			<div class="bottom_text">
				<p>版权所有：易贝乐成长中心</p>
				<p>技术支持：苏州期遇软件有限公司</p>
			</div>
		</div>

		<!--底部导航-->
		<Footer :navs="nav"></Footer>
	</div>
</template>

<script>
	import DataRequestFactory from '@/factories/dataRequestFactory.js'
	import Footer from '../components/Footer.vue'
	export default {
		name: '',
		data() {
			return {
				nav: {
					sy: true,
					jchd: false,
					yyst: false,
					wd: false,
				},
				info: {
					dataList: []
				},
			}
		},
		components: {
			Footer
		},
		created() {
			if (screen.width < 1080) {
				var width = screen.width // 通过window.screen.width获取屏幕的宽度
				var offWidth = width / 21.60 // 这里用宽度/30表示1rem取得的px
				document.getElementsByTagName('html')[0].style.fontSize = offWidth + 'px' // 把rem的值复制给顶级标签html的font-size
			}

			DataRequestFactory.I010010().then((response) => {
				this.info = response
				console.log(response)
			})
		},
		mounted() {
			let screenHeight = window.innerHeight;
			let fontSize = getComputedStyle(window.document.documentElement)['font-size']
			let heightDiff = screenHeight - parseInt(fontSize) * 3
			$(".scroll_area").css("height", heightDiff + "px")
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import '../assets/css/pages/H010010.css';
	@import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H010010.vue